import { CameraModel } from 'src/app/engine/models/camera.model';
import { CameraMotionModel } from '../../models/camera-motion.model';

export class ClearCamera {
  static readonly type = '[Engine Camera] Clear Camera';
  constructor(public id: string) { }
}

export class StoreCamera {
  static readonly type = '[Engine Camera] Store Camera';
  constructor(public id: string, public camera?: CameraModel) { }
}

export class SetCamera {
  static readonly type = '[Engine Camera] Set Camera';
  constructor(public camera: CameraModel) { }
}

export class MoveCamera {
  static readonly type = '[Engine Camera] Move Camera';
  constructor(public cameraMotion: CameraMotionModel) { }
}

export class StopCamera {
  static readonly type = '[Engine Camera] Stop Camera';
  constructor() { }
}

export class ZoomCamera {
  static readonly type = '[Engine Camera] Zoom Camera';
  constructor(public value: number) { }
}

export class PanCameraX {
  static readonly type = '[Engine Camera] Pan Camera X';
  constructor(public value: number) { }
}

export class PanCameraY {
  static readonly type = '[Engine Camera] Pan Camera Y';
  constructor(public value: number) { }
}

export class RotateCameraX {
  static readonly type = '[Engine Camera] Rotate Camera X';
  constructor(public value: number) { }
}

export class RotateCameraY {
  static readonly type = '[Engine Camera] Rotate Camera Y';
  constructor(public value: number) { }
}

export class SetPanMode {
  static readonly type = '[Engine Camera] Set Pan Mode';
  constructor(public mode: 'pan' | 'rotate') { }
}

export class SetZoomed {
  static readonly type = '[Engine Camera] Set Pan Mode';
  constructor(public zoomed: boolean) { }
}

export class LockCamera {
  static readonly type = '[Engine Camera] Lock camera';
  constructor(public lock: boolean) { }
}
